import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useOffset } from 'Context/LayoutContext/OffsetProvider';

import { Box, Flex, Image, Text } from '../Base';
import withConfig from '../../Context/ConfigContext/hoc';

import PassportLogin from './PassportLogin.view';
import LoginBanner from './LoginBanner.view';

const CONTENT_MAX_WIDTH = 700;
const FOOTER_BOTTOM_SPACE = 6;

const LoginViewContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
`;

const LoginContent = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH}px;
  flex: 1 1 auto;
`;

/**
 * @typedef CopyrightWithLogoProps
 * @property {string} note
 *
 * @param {CopyrightWithLogoProps} props
 */
const CopyrightWithLogo = ({ note }) => (
  <Flex mt={'auto'} pt={9} alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
    <Box>
      <Image width={52} height={24} src={'/assets/images/learnCorpLogo/learnCorpLogo.png'} />
    </Box>
    <Text
      mt={2}
      textStyle={'xxs'}
      textAlign={'center'}
      fontFamily={"'IBM Plex Sans Thai Looped', Anuphan, sans-serif"}
      color={'myPath.textColor.disabled'}
    >
      {note}
    </Text>
  </Flex>
);

const Login = ({ onPassportLoginClick = () => {}, note }) => {
  const { t } = useTranslation('registerLogin');
  const { space } = useTheme();
  const { topOffset, bottomOffset } = useOffset();

  return (
    <LoginViewContainer>
      <LoginBanner topOffset={topOffset} />
      <LoginContent pt={8} px={4} pb={`${space[FOOTER_BOTTOM_SPACE] + bottomOffset}px`}>
        <Text
          mb={4}
          textAlign={'center'}
          fontFamily={"'IBM Plex Sans Thai Looped', Anuphan, sans-serif"}
          textStyle={'body1'}
          color={'greyscale.grey3'}
        >
          {t('SIGN_UP_OR_LOGIN')}
        </Text>
        <PassportLogin onPassportLoginClick={onPassportLoginClick} />
        <CopyrightWithLogo note={note} />
      </LoginContent>
    </LoginViewContainer>
  );
};

Login.propTypes = {
  onPassportLoginClick: PropTypes.func,
  note: PropTypes.string,
};

CopyrightWithLogo.propTypes = {
  note: PropTypes.string,
};

export default withConfig(Login);
